import { ApiResponse, DataObject } from "@/types";
import { HeroResponse } from "./interface";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { useFormMutation } from "@/hooks/useFormMutation";
import { HeroPayload } from "./validation";

const getHero = async (): Promise<ApiResponse<DataObject<HeroResponse>>> => {
  return await fetcher(`master/hero/1`);
};

export const useGetHero = () => {
  return useQuery<ApiResponse<DataObject<HeroResponse>>, Error>({
    queryKey: ["useGetHero"],
    queryFn: () => getHero(),
  });
};

// Mutation
export const useHero = () => {
  return useFormMutation<
    ApiResponse<DataObject<HeroResponse>>,
    Error,
    HeroPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<HeroResponse>>> => {
      const endpoint = `master/hero/1`;
      const response: ApiResponse<DataObject<HeroResponse>> = await sendData(
        endpoint,
        data,
        "PUT",
        true
      );
      return response;
    },
    loadingMessage: "Memperbarui data...",
    successMessage: "Data berhasil diperbarui",
  });
};
